<div class="d-lg-flex" *ngIf="outtageSetting?.value">
  <p style="color: #212121;">
    <span class="wrapText">
      <div [innerHTML]="outtageSetting.value"></div>
    </span>
  </p>
</div>